// extracted by mini-css-extract-plugin
export default {"backButton":"nav-back-arrow-button-module__backButton___RPfQM"};